import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Toast.scss';

export default class Toast extends Component {
  UNSAFE_componentWillMount() {
    this.toast = null;
  }

  componentWillUnmount() {
    clearTimeout(this.toast);
  }

  handleShowToast = () => {
    try {
      const { id, handleClearState } = this.props;
      const toast = document.getElementById(id);
      toast.className += ' show';

      this.toast = setTimeout(() => {
        toast.className = toast.className.replace(' show', '');

        if (handleClearState) {
          handleClearState();
        }
      }, 3700);
    } catch (error) {
      return null;
    }
  }

  render() {
    const { text, id } = this.props;

    return (
      <div className="Toast" id={id}>
        {text}
      </div>
    );
  }
}

Toast.propTypes = {
  'text': PropTypes.any,
  'id': PropTypes.string.isRequired,
  'handleClearState': PropTypes.func,
};
